import {
  FETCH_APPOINTMENTS_BETWEEN_DATES,
  FETCH_APPOINTMENTS_BETWEEN_DATES_SUCCESS,
  ON_CREATE_APPOINTMENTS,
  SHOW_APPOINTMENTS_LOADER,
  SAVE_APPOINTMENTS_SUCCESS,
  SHOW_APPOINTMENTS_MESSAGE,
  HIDE_APPOINTMENTS_MESSAGE,
  FETCH_APPOINTMENTS_DOCTORS,
  FETCH_APPOINTMENTS_DOCTORS_SUCCESS,
  ON_DELETE_APPOINTMENTS,
  DELETE_APPOINTMENTS_SUCCESS,
} from 'constants/ActionTypes';

export const fetchAppointmentsBetweenDates = (startDate, endDate) => {
  return {
    type: FETCH_APPOINTMENTS_BETWEEN_DATES,
    payload: {
      startDate,
      endDate
    }
  };
}
export const fetchAppointmentsBetweenDatesSuccess = (data) => {
  return {
    type: FETCH_APPOINTMENTS_BETWEEN_DATES_SUCCESS,
    payload: data
  };
}
export const onCreateAppointments = (data) => {
  return {
    type: ON_CREATE_APPOINTMENTS,
    payload: data
  };
};
export const showAppointmentsLoader = () => {
  return {
    type: SHOW_APPOINTMENTS_LOADER
  };
};
export const saveAppointmentsSuccess = (appointments) => {
  return {
    type: SAVE_APPOINTMENTS_SUCCESS,
    payload: appointments
  };
};
export const showAppointmentsMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_APPOINTMENTS_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const hideAppointmentsMessage = () => {
  return {
    type: HIDE_APPOINTMENTS_MESSAGE
  };
};
export const fetchDoctors = () => {
  return {
    type: FETCH_APPOINTMENTS_DOCTORS
  }
}
export const fetchDoctorsSuccess = (data) => {
  return {
    type: FETCH_APPOINTMENTS_DOCTORS_SUCCESS,
    payload: data
  };
}
export const onDeleteAppointments = (id) => {
  return {
    type: ON_DELETE_APPOINTMENTS,
    payload: { id }
  };
}
export const deleteAppointmentsSuccess = (id) => {
  return {
    type: DELETE_APPOINTMENTS_SUCCESS,
    payload: { id }
  };
}



// WEBPACK FOOTER //
// ./actions/Appointments.js